/**
 * ThemeToggle — flips ThemeContext contrast (DESIGN_SPEC §9 forbids real
 * light mode in v1; toggle cycles normal ↔ high contrast).
 */

import { useTheme } from "@/contexts/theme/ThemeContext";

import { themeToggleCopy as C } from "./ThemeToggle.copy";

export function ThemeToggle(): React.ReactElement {
  const { contrast, setContrast } = useTheme();
  const isHigh = contrast === "high";
  return (
    <button
      type="button"
      data-testid="theme-toggle"
      data-contrast={contrast}
      onClick={() => setContrast(isHigh ? "normal" : "high")}
      aria-label={C.toggleContrastLabel}
      aria-pressed={isHigh}
      className="font-plex-mono text-paper-cream-dim border-ledger-line rounded-ledger-line"
      style={{
        display: "inline-flex", alignItems: "center", gap: "0.375rem",
        padding: "4px 10px", fontSize: "0.781rem",
        background: "transparent", border: "1px solid var(--ledger-line)",
        cursor: "pointer",
      }}
    >
      <span aria-hidden style={{ color: "var(--brass-cue)" }}>
        {isHigh ? C.highGlyph : C.normalGlyph}
      </span>
      <span>{isHigh ? C.highText : C.normalText}</span>
    </button>
  );
}

export default ThemeToggle;
